import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { environment } from "../../../../environments/environment";

@Injectable()
export class ResultadoService {
  apiUrl = environment.apiUrl;

  constructor(private http: Http) {}

  resultadoParcial(param): Promise<any> {
    return this.http
      .get(
        `${this.apiUrl}/plano-trabalho-has-proponente/pesquisa-publica?page=0&size=300&planoTrabalho=${param}`
      )
      .toPromise()
      .then((response) => response.json().content);
  }

  pesquisarResultadoCredenciamento(tipo, eixoPrograma): Promise<any> {
    return this.http
      .get(
        `${this.apiUrl}/eixo-programa-has-entidade-proponente-cadastrada/pesquisa-publica/filtro?page=0&size=300&tipo=${tipo}&eixoPrograma=${eixoPrograma}`
      )
      .toPromise()
      .then((response) => response.json().content);
  }
}
